import { get, post, deleteApi } from "../GenericServices";

const TimesheetPortal = {
  listProject: (queryString) => {
    return get(`timesheet-portal/project?${queryString}`);
  },
  listProjectTask: (queryString) => {
    return get(`timesheet-portal/project-task?${queryString}`);
  },
  deleteLineTimesheet: (LineId, queryString) => {
    return deleteApi(`timesheet-portal/${LineId}?${queryString}`);
  },
  saveTimesheet: (month, queryString, dto) => {
    return post(`timesheet-portal/${month}?${queryString}`, dto);
  },
  approveTimesheet: (month, queryString) => {
    return post(`timesheet-portal/${month}/release?${queryString}`);
  },
  downloadTimesheet: (month, queryString) => {
    return post(`timesheet/${month}/export?${queryString}`);
  },
  listProjectApproval: (queryString) => {
    return get(`timesheet-approval/project?${queryString}`);
  },
  listUser: (queryString) => {
    return get(`timesheet-portal/user-internal?${queryString}`);
  },
  TimesheetData: (queryString) => {
    return get(`timesheet-portal?${queryString}`);
  },
  addRowTimesheet: (month, projectTaskId, queryString) => {
    return post(`timesheet-portal/${month}/project-task/${projectTaskId}?${queryString}`);
  },
  getMonth: () => {
    return get(`timesheet-portal/current-month`);
  },
  addRowAdjTimesheet: (month, projectTaskMainId, queryString, dto) => {
    return post(`timesheet-portal/${month}/project-task/${projectTaskMainId}/adjustment-structure?${queryString}`, dto);
  },
  reopenApprovalTimesheet: (id, queryString) => {
    return post(`timesheet-portal/cancel/${id}/?${queryString}`);
  },
  getTimesheetApprovalProjects: (projectId) => {
    return get(`timesheet-approval/project/${projectId}`);
  },
  submitTimesheetApproval: (projectId, payload) => {
    return post(`timesheet-approval/project/${projectId}`, payload);
  },
  downloadTimesheetReport: (queryString) => {
    return get(`timesheet-report/export?${queryString}`);
  },
  downloadTimesheetApprovalList: () => {
    return get(`timesheet-approval/export`);
  },
};

export default TimesheetPortal;
